export default __webpack_public_path__ + "static/media/View of Foundation Hall Convention layout.da5bd6de.jpeg";